import React from 'react'
import PropTypes from 'prop-types'
import styles from './_privacyStyles.css'
import { FormattedHTMLMessage } from 'react-intl'

function StickyFooter (props) {
  const { children } = props
  const termsLink = 'https://account.underarmour.com/terms-and-conditions'
  const privacyLink = 'https://account.underarmour.com/privacy'

  return (<div className={styles.privacyFooter}>
    <FormattedHTMLMessage
      id='privacy_center.privacy_and_terms'
      defaultMessage={'<a href="{ privacyLink }" target="_blank">Privacy Policy</a> & <a href="{ termsLink }" target="_blank">Terms of Use</a>.'}
      values={ {
        termsLink,
        privacyLink,
      } }
    />
    { children }
  </div>)
}

StickyFooter.propTypes = {
  children: PropTypes.object,
}

export default StickyFooter



// WEBPACK FOOTER //
// ./src/components/privacy_center/util/MobileFooter.jsx